import { render, staticRenderFns } from "./SelectedCustomer.vue?vue&type=template&id=8c964de4&scoped=true&"
import script from "./SelectedCustomer.vue?vue&type=script&lang=ts&"
export * from "./SelectedCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedCustomer.vue?vue&type=style&index=0&id=8c964de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c964de4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8c964de4', component.options)
    } else {
      api.reload('8c964de4', component.options)
    }
    module.hot.accept("./SelectedCustomer.vue?vue&type=template&id=8c964de4&scoped=true&", function () {
      api.rerender('8c964de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/views/CallCenter/SelectedCustomer.vue"
export default component.exports